import { Inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NetworkService } from '@ridango/core';
import Env from '@ridango/core/env';
import { TICKETS_CACHE_CLEARED } from './app.component';

@Injectable()
export class OfflineTicketDetailsGuard implements CanActivate {
    constructor(
        @Inject('ENV') private env: Env,
        private networkService: NetworkService,
        private router: Router,
        private translate: TranslateService
    ) {}

    canActivate(): boolean {
        if (!this.env.IS_NEW_AFC) {
            return true;
        }

        const isOnline = this.networkService.getCurrentStatus();
        if (isOnline === false && localStorage.getItem(TICKETS_CACHE_CLEARED)) {
            this.router.navigate([this.translate.currentLang, 'account', 'tickets']);
            return false;
        }

        return true;
    }
}
